module.exports = __webpack_public_path__ + "static/media/drupal.4a2db635.png";